import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NetworkGood = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box display="flex" justifyContent="center" marginBottom="16px">
        <img
          src="network-quality-good.png"
          alt="network quality good"
          width={200}
          style={{ maxWidth: '100vW' }}
        />
      </Box>
      <Box>
        <Typography variant="h5" gutterBottom align="center">
          {t('Your Connection is good')}
        </Typography>
      </Box>
      <Box sx={{ maxWidth: '375px' }}>
        <Typography
          gutterBottom
          // align="center"
          sx={{ textWrap: 'wrap', fontSize: '14px' }}
        >
          {t(
            "If you are experiencing choppy sound, frozen video or call delays, it's likely due to the network of the other person you'are talking to. Network problems can occur even if you have a fast network."
          )}
        </Typography>
      </Box>
    </>
  );
};

export default NetworkGood;
